import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { useMemo } from 'react';
import useFetchPropertyGroups from './useFetchPropertyGroups';
export default function useFetchCrmObjectProperties(objectTypeId) {
  const _useFetchPropertyGrou = useFetchPropertyGroups(objectTypeId),
    {
      data
    } = _useFetchPropertyGrou,
    rest = _objectWithoutPropertiesLoose(_useFetchPropertyGrou, _excluded);
  const flatProperties = useMemo(() => data.map(propertyGroup => propertyGroup.properties).flat(), [data]);
  return useMemo(() => {
    return Object.assign({
      data: flatProperties
    }, rest);
  }, [flatProperties, rest]);
}